<div class="column">
  <div class="column__loading" *ngIf="loading">
    <app-spinner size="large"></app-spinner>
    <div class="column__loading-label">{{ loadingLabel }}</div>
  </div>

  <!-- Header -->
  <div class="column__header" *ngIf="showHeader && !loading">
    <div class="column__title">
      <div class="column__label">{{ label }}</div>
      
      <div class="column__actions">
        <ng-content select="[column-actions]"></ng-content>
      </div>
    </div>

    <ng-content select="[column-header]"></ng-content>
  </div>

  <ng-container *ngIf="!loading">
    <div class="column__tabs" *ngIf="columnGroups.length > 1">
      <span
        *ngFor="let columnGroup of columnGroups; let i = index"
        (click)="handleColumnGroupSelect(columnGroup)"
        class="column__tab"
        [ngClass]="{
          'column__tab--selected': isColumnGroupSelected(columnGroup)}"
        >
        <div class="column__tab-label">
          {{ columnGroup.label }}
        </div>
      </span>
    </div>
  
    <!-- Group -->
    <div class="column__group">
      <ng-content select="app-column-group"></ng-content>
    </div>
  
    <!-- Footer -->
    <div class="column__footer" *ngIf="!loading">
      <ng-content select="[column-footer]"></ng-content>
    </div>
  </ng-container>
</div>